export const footer = {
	nfz: { pl: 'Narodowy Fundusz Zdrowia' },
	declaration: { pl: 'Deklaracja dostępności' },
	privatePolicy: { pl: 'Polityka prywatności' },
	materials: {
		pl: 'Materiał współfinansowany przez Unię Europejską ze środków Europejskiego Funduszu Społecznego'
	}
};
